// extracted by mini-css-extract-plugin
module.exports = {"container":"sponsor_container___0fSN","profile":"sponsor_profile__rmXgV","signature":"sponsor_signature__NGyOi"};